import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsKlimakenntageSommer(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 239 239"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>{'.kkt-icon-st{fill:#34c17b}'}</style>
      </defs>
      <g className="kkt-icon-st" id="c">
        <path d="M119.5,187.7c-37.6,0-68.2-30.59-68.2-68.2s30.59-68.2,68.2-68.2,68.2,30.59,68.2,68.2-30.59,68.2-68.2,68.2ZM119.5,58.3c-33.74,0-61.2,27.45-61.2,61.2s27.45,61.2,61.2,61.2,61.2-27.45,61.2-61.2-27.45-61.2-61.2-61.2Z" />
        <path d="M119.5,39.33c-1.93,0-3.5-1.57-3.5-3.5V3.5c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5v32.33c0,1.93-1.57,3.5-3.5,3.5Z" />
        <path d="M178.67,63.83c-.9,0-1.79-.34-2.48-1.03-1.37-1.37-1.37-3.58,0-4.95l22.86-22.86c1.37-1.37,3.58-1.37,4.95,0,1.37,1.37,1.37,3.58,0,4.95l-22.86,22.86c-.68.68-1.58,1.03-2.48,1.03Z" />
        <path d="M235.5,123h-32.33c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h32.33c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5Z" />
        <path d="M201.53,205.03c-.9,0-1.79-.34-2.48-1.03l-22.86-22.86c-1.37-1.37-1.37-3.58,0-4.95,1.37-1.37,3.58-1.37,4.95,0l22.86,22.86c1.37,1.37,1.37,3.58,0,4.95-.68.68-1.58,1.03-2.48,1.03Z" />
        <path d="M119.5,239c-1.93,0-3.5-1.57-3.5-3.5v-32.33c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5v32.33c0,1.93-1.57,3.5-3.5,3.5Z" />
        <path d="M37.48,205.03c-.9,0-1.79-.34-2.48-1.03-1.37-1.37-1.37-3.58,0-4.95l22.86-22.86c1.37-1.37,3.58-1.37,4.95,0,1.37,1.37,1.37,3.58,0,4.95l-22.86,22.86c-.68.68-1.58,1.03-2.48,1.03Z" />
        <path d="M35.83,123H3.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h32.33c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5Z" />
        <path d="M60.33,63.83c-.9,0-1.79-.34-2.48-1.03l-22.86-22.86c-1.37-1.37-1.37-3.58,0-4.95,1.37-1.37,3.58-1.37,4.95,0l22.86,22.86c1.37,1.37,1.37,3.58,0,4.95-.68.68-1.58,1.03-2.48,1.03Z" />
      </g>
    </svg>
  )
}
export default SvgMsKlimadashboardIconsKlimakenntageSommer
